import React, { useState } from "react";
import { Link, useHistory } from "react-router-dom";
import FeedbackModal from "../shared/FeedbackModal";

const Disclaimer = () => {
  const [feedbackOpen, setFeedbackOpen] = useState(false);
  const history = useHistory();

  const handleProceed = () => {
    history.push("/choosetype");
  };

  const openHelp = () => {
    if (typeof window !== "undefined" && typeof window.openXlog3DHelp === "function") {
      window.openXlog3DHelp();
    } else {
      window.dispatchEvent(new Event("xlog3d:open-help"));
    }
  };

  return (
    <div id="page" style={{ height: "100vh", display: "flex", flexDirection: "column", background: "#f0f0f0" }}>
      {/* Header with Logo */}
      <div style={{ flexShrink: 0, padding: "12px 15px", textAlign: "center" }}>
        <Link to="/">
          <img
            src="/XLog3D Logo_Red.png"
            alt="Xlog3D Logo"
            style={{ height: "85px" }}
          />
        </Link>
      </div>

      <div
        style={{
          flex: 1,
          minHeight: 0,
          overflowY: "auto",
          WebkitOverflowScrolling: "touch",
          padding: "0 15px 12px",
        }}
      >
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12">
              {/* Main Card */}
              <div style={{
                background: "white",
                borderRadius: "12px",
                boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
                padding: "20px",
                textAlign: "center"
              }}>
                {/* Credits Section */}
                <div style={{ marginBottom: "15px", textAlign: "center" }}>
                  <div style={{ marginBottom: "12px" }}>
                    <div style={{ fontSize: "14px", color: "#333" }}>Concept & Geological Algorithm</div>
                    <div style={{ fontSize: "14px", color: "#333", fontWeight: "700", textDecoration: "underline" }}>Yogendra Deva</div>
                    <div style={{ fontSize: "13px", color: "#444", fontStyle: "italic" }}>Consulting Engineering Geologist | Former Director (VRS), Geological Survey of India</div>
                  </div>
                  <div style={{ marginBottom: "12px" }}>
                    <div style={{ fontSize: "14px", color: "#333" }}>Project Coordination & Algorithm Support</div>
                    <div style={{ fontSize: "14px", color: "#333", fontWeight: "700", textDecoration: "underline" }}>Mugdha Patwardhan</div>
                    <div style={{ fontSize: "13px", color: "#444", fontStyle: "italic" }}>Consulting Engineering Geologist</div>
                  </div>
                  <div>
                    <div style={{ fontSize: "14px", color: "#333" }}>Software Development</div>
                    <div style={{ fontSize: "14px", color: "#333", fontWeight: "700" }}>Appsphere Softwares LLP</div>
                  </div>
                </div>

                {/* Disclaimer Card */}
                <div style={{
                  background: "#f8f9fa",
                  borderRadius: "10px",
                  border: "1px solid #e9ecef",
                  padding: "15px 18px",
                  textAlign: "left"
                }}>
                  {/* Disclaimer Title */}
                  <h6 style={{ fontWeight: "700", marginBottom: "12px", color: "#333", textAlign: "left" }}>Disclaimer & Terms of Use</h6>
                  <ol style={{
                    paddingLeft: "18px",
                    margin: 0,
                    fontSize: "13px",
                    lineHeight: "1.5",
                    color: "#444"
                  }}>
                    <li style={{ marginBottom: "8px" }}>
                      Xlog3D is a decision-support and visualisation tool intended for use by qualified engineering geology and tunnelling professionals.
                    </li>
                    <li style={{ marginBottom: "8px" }}>
                      Outputs must be interpreted using professional judgment and in conjunction with site observations, investigations, and other analyses.
                    </li>
                    <li>
                      The developers shall not be liable for decisions taken solely on the basis of software outputs.
                    </li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Action buttons: Proceed, Help, Exit (feedback) */}
      <div
        style={{
          flexShrink: 0,
          padding: "12px 15px",
          display: "flex",
          gap: "10px",
          background: "#f0f0f0",
        }}
      >
        <button
          onClick={handleProceed}
          className="btn btn-m rounded-l bg-green-dark font-900 text-uppercase"
          style={{ flex: 1 }}
        >
          Proceed
        </button>
        <button
          type="button"
          onClick={openHelp}
          className="btn btn-m rounded-l bg-green-dark font-900 text-uppercase"
          style={{ flex: 1 }}
        >
          User Manual
        </button>
        <button
          type="button"
          onClick={() => setFeedbackOpen(true)}
          className="btn btn-m rounded-l bg-green-dark font-900 text-uppercase"
          style={{ flex: 1 }}
        >
          Exit
        </button>
      </div>
      <FeedbackModal
        open={feedbackOpen}
        onClose={() => setFeedbackOpen(false)}
        screenLabel="Disclaimer"
        attachGraph={false}
        redirectUrl="https://www.dhawanacademy.com/"
      />
    </div>
  );
};

export default Disclaimer;
